import { types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';

import IsoDate from '../types/IsoDate';
import Event from './Event';
import DocumentMetadata from './DocumentMetadata';


const BaseDocument = types
    .model('BaseDocument', {
        id: types.optional(types.identifier, () => uuid()),

        schemaVersion: 1,

        // These values are defaulted to the creation date and will
        // be automatically maintained/overwritten by the Profiles BE
        createdAt: types.maybe(IsoDate),
        updatedAt: types.maybe(IsoDate),
        userUpdatedAt: types.maybe(IsoDate),
        
        metadata: types.optional(DocumentMetadata, {}),

        events: types.array(Event),
    })
    .actions(self => ({
        // The contents of this function will be updated to call the profile-faas 
        // raise-event endpoint at some point.
        trackEvent({ type, details, requestMetadata: metadata }) {
            if (!type) {
                throw new TypeError('Must specify an event type', 'BaseDocument.js');
            }

            self.events.push({
                type,
                details,
                metadata,
            });
        },
    }));

export default BaseDocument;